import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['menu', 'hamburger'];
  static requiredTargets = [];
  // TARGETS
  declare menuTarget: HTMLDivElement;
  declare hamburgerTarget: HTMLButtonElement;

  mobileNavToggle() {
    this.menuTarget.classList.toggle('hidden');
    this.hamburgerTarget.classList.toggle('active');
  }
}
